import { createElement } from 'react';
import PropTypes from 'prop-types';
import styles, { mainCls } from './styles';
import createStyle from '../../Utils/createStyle';

const useStyles = createStyle(styles);

/**
 * The grid item to use in conjunction with Grid component
 */
export default function GridItem({
  taghtml,
  children,
  className,
  cols,
  sm,
  md,
  lg,
  behavior,
  align,
  push,
  ...props
}) {
  const cls = useStyles();
  const classes = [
    mainCls,
    className,
    cls[mainCls],
    cols ? cls[`${mainCls}--cols-${cols}`] : '',
    sm ? cls[`${mainCls}--sm-${sm}`] : '',
    md ? cls[`${mainCls}--md-${md}`] : '',
    lg ? cls[`${mainCls}--lg-${lg}`] : '',
    behavior ? cls[`${mainCls}--behavior-${behavior}`] : '',
    align ? cls[`${mainCls}--align-${align}`] : '',
    push ? cls[`${mainCls}--push-${push}`] : '',
  ].filter(c => c).join(' ').trim();

  return createElement(
          (taghtml || 'div'),
          {
            className: classes,
            ...props,
          },
          children,
        );
};

GridItem.propTypes = {
  /**
   * Optional: html tag to use (defaults to div)
   */  
  taghtml: PropTypes.string,
  /**
   * Component class
   */
  className: PropTypes.string,
  /**
   * Item width in number of columns (based on 12 columns)
   */
  cols: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  /**
   * Item width in number of columns from small size devices
   */
  sm: PropTypes.string,
  /**
   * Item width in number of columns from medium size devices
   */
  md: PropTypes.string,
  /**
   * Item width in number of columns from large size devices
   */
  lg: PropTypes.string,
  /**
   * Behavior of the item in relation to the parent.
   */
  behavior: PropTypes.oneOf(['', 'fixed', 'stretch', 'no-shrink']),
  /**
   * Vertical alignment of the item
   */
  align: PropTypes.oneOf(['', 'top', 'middle', 'bottom']),
  /**
   * Push the item from one of the sides
   */
  push: PropTypes.oneOf(['', 'top', 'right', 'bottom', 'left']),
}

GridItem.defaultProps = {
  taghtml: null,
  className: '',
  cols: '',
  md: '',
  lg: '',
  behavior: '',
  align: '',
  push: '',
}
